import { createContext } from "react";

export const PriceGuideSubmitContext = createContext({
    priceGuideSubmit: false,
    setPriceGuideSubmit: () => {}
  });
  